import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import CartPage from "@/pages/CartPage";
import Checkout from "@/pages/Checkout";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import About from "@/pages/About";
import Journal from "@/pages/Journal";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import ExchangesReturns from "@/pages/ExchangesReturns";
import CareInstructions from "@/pages/CareInstructions";
import SizingFit from "@/pages/SizingFit";
import ShippingDelivery from "@/pages/ShippingDelivery";
import SignatureMini from "@/pages/SignatureMini";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Header />
            <CartDrawer />
            <Toaster
              position="top-center"
              toastOptions={{
                style: {
                  background: "#1A1A19",
                  color: "#FDFBF7",
                  border: "none",
                  borderRadius: 0,
                  fontFamily: "Outfit, sans-serif",
                  fontSize: "13px",
                  letterSpacing: "0.04em",
                },
              }}
            />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shop/signature-mini" element={<Shop />} />
              <Route path="/shop/:slug" element={<ProductDetail />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/account" element={<Account />} />
              <Route path="/about" element={<About />} />
              <Route path="/journal" element={<Journal />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/exchanges-returns" element={<ExchangesReturns />} />
              <Route path="/care-instructions" element={<CareInstructions />} />
              <Route path="/sizing-fit" element={<SizingFit />} />
              <Route path="/shipping-delivery" element={<ShippingDelivery />} />
            </Routes>
            <Footer />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
